import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root',
})
export class InviteService {
  constructor(private readonly httpService: AmplifyHttpClient) {}

  /**
   * @deprecated Invites are now returned as part of the getUserConnections
   */
  getInvites(user_id, search) {
    return null;
  }

  /**
   * search @params {
   * user_id: Int,
   * full_name: String,
   * email: String}
   */
  createInvite(params) {
    return this.httpService.post<any>(`api/user/create-invite`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  dropInvite(params) {
    return this.httpService.post<any>(`api/user/drop-invite`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
